import { CARD_SIZES, imgProps } from "../../lib/images";

/**
 * The one <img> for content photos: srcset with every generated width (scripts/images.mjs), a layout-accurate `sizes`,
 * width/height to reserve space, async decoding and lazy loading — `priority` (above the fold) loads eagerly with
 * fetchpriority=high instead. `max` caps the largest candidate (default 1080w ≈ 2.6× a phone card; pass 1600 for
 * full-bleed or gallery images). Any extra props (style, data-*, event handlers) pass straight through.
 */
export const ResponsiveImage = ({ src, alt = "", sizes = CARD_SIZES, max = 1080, priority = false, className = "", testId, ...rest }) => (
  <img
    {...imgProps(src, sizes, max)}
    alt={alt}
    loading={priority ? undefined : "lazy"}
    fetchPriority={priority ? "high" : undefined}
    decoding="async"
    className={className}
    data-testid={testId}
    {...rest}
  />
);
